import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DesignAngularKitModule } from 'design-angular-kit';
import { FindRequestDto } from '../../models/find-request.dto';
import { RequestDto } from '../../models/request.dto';
import { AuthService } from '../../services/auth.service';
import { RequestService } from '../../services/request.service';
import { DashboardCardComponent } from './components/dashboard-card/dashboard-card.component';
import { OwnRequestsComponent } from './components/own-requests/own-requests.component';
import { RapidSearchComponent } from './components/rapid-search/rapid-search.component';
import { RequestCarouselComponent } from './components/request-carousel/request-carousel.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    DesignAngularKitModule,
    DashboardCardComponent,
    RouterModule,
    RequestCarouselComponent,
    RapidSearchComponent,
    OwnRequestsComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit, OnDestroy {
  ownRequest: RequestDto[] = [];
  requestsToComplete: RequestDto[] = [];
  totalToComplete: number = 0;
  requestsToManage: RequestDto[] = [];
  totalToManage: number = 0;
  closedRequests: RequestDto[] = [];
  totalClosed: number = 0;
  totalToManagePIC: number = 0;
  totalToManageSS: number = 0;
  totalToManageNEW: number = 0;
  totalToManageCP: number = 0;
  totalToManageCS: number = 0;
  totalClosedEND: number = 0;
  totalClosedDEL: number = 0;
  totalClosedCHI: number = 0;
  totalToManageDAT: number = 0;
  totalToManageTPV: number = 0;
  totalToManageTPA: number = 0;
  totalToManageVAL: number = 0;
  totalToManageCPZ: number = 0;
  totalToManageCST: number = 0;
  linksToManage: any[] = [];
  linksClosed: any[] = [];
  linksSol: any[] = [];

  totalUvmSol1: number = 0;
  totalUvmSol2: number = 0;
  totalUvmSol3: number = 0;
  totalUvmSol: number = 0;

  searchContexts = [
    { label: 'Tutte le richieste', value: 'ALL' },
    { label: 'Richieste senza UVM', value: 'NO_UVM' },
    { label: 'Richieste con UVM', value: 'ONLY_UVM' },
  ];
  selectedContext = this.searchContexts[0];

  progress = 0;
  isReloading = false;
  private intervalId?: number;

  constructor(
    private requestService: RequestService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loadStats();
    // this.scheduleReload();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  // scheduleReload(): void {
  //   if (this.intervalId) {
  //     clearInterval(this.intervalId);
  //   }

  //   this.progress = 0;
  //   const step = 100 / 60;

  //   this.intervalId = window.setInterval(() => {
  //     this.progress += step;

  //     if (this.progress >= 100) {
  //       clearInterval(this.intervalId);
  //       this.loadStats();
  //     }
  //   }, 1000);
  // }

  loadStats(): void {
    this.isReloading = true;

    if (this.authService.isOperatoreUvm) {
      this.loadRequestsForUvm();
    } else if(this.authService.isOperatoreUvcp) {
      this.loadRequestsForUvcp();
    } else if(this.authService.isOperatoreSuperUser) {
      this.loadRequestsForSuperUser();
    } else {
      this.loadRequests();
    }

    const isTransitionUvm =
      this.selectedContext.value === 'ONLY_UVM'
        ? true
        : this.selectedContext.value === 'NO_UVM'
        ? false
        : undefined;
    
    if (this.authService.isOperatoreUvm) {
      this.requestService
      .getStatusStatsUvm({
        ownershipUserCode: this.authService.userInfo.username,
        isTransitionUvm,
      })
      .subscribe((stats) => {
        const getTotal = (statusCodes: string[]) =>
          stats
            .filter((s) => statusCodes.includes(s.status))
            .reduce((sum, s) => sum + s.total, 0);

        this.totalToComplete = getTotal(['DVAL']);
        this.totalToManage = getTotal(['PIC','SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST']);
        this.totalClosed = getTotal(['VALL']);
        this.totalToManageNEW = getTotal(['NEW']);
        this.totalToManagePIC = getTotal(['PIC']);
        this.totalToManageSS = getTotal(['SS']);
        this.totalToManageCP = getTotal(['CP']);
        this.totalToManageCS = getTotal(['CS']);
        this.totalClosedEND = getTotal(['END']);
        this.totalClosedDEL = getTotal(['DEL']);
        this.totalClosedCHI = getTotal(['CHI']);

        this.totalUvmSol1 = getTotal(['SOL1']);
        this.totalUvmSol2 = getTotal(['SOL2']);
        this.totalUvmSol3 = getTotal(['SOL3']);
        this.totalUvmSol = getTotal(['SOL1', 'SOL2', 'SOL3']);

      this.refreshData();
      this.isReloading = false;
      // this.scheduleReload();
    });
    } else if(this.authService.isOperatoreUvcp) {

      this.requestService
      .getStatusStatsUvcp({
        ownershipUserCode: this.authService.userInfo.username,
      })
      .subscribe((stats) => {
        const getTotal = (statusCodes: string[]) =>
          stats
            .filter((s) => statusCodes.includes(s.status))
            .reduce((sum, s) => sum + s.total, 0);

        this.totalToComplete = getTotal(['DVAL']);
        this.totalToManage = getTotal(['TPV']);
        this.totalClosed = getTotal(['VALL']);
        this.totalToManageNEW = getTotal(['NEW']);
        this.totalToManagePIC = getTotal(['PIC']);
        this.totalToManageSS = getTotal(['SS']);
        this.totalToManageCP = getTotal(['CP']);
        this.totalToManageCS = getTotal(['CS']);
        this.totalClosedEND = getTotal(['END']);
        this.totalClosedDEL = getTotal(['DEL']);
        this.totalClosedCHI = getTotal(['CHI']);

        this.totalUvmSol1 = getTotal(['SOL1']);
        this.totalUvmSol2 = getTotal(['SOL2']);
        this.totalUvmSol3 = getTotal(['SOL3']);
        this.totalUvmSol = getTotal(['SOL1', 'SOL2', 'SOL3']);

      this.refreshData();
      this.isReloading = false;
      // this.scheduleReload();
    });
    } else if(this.authService.isOperatoreSuperUser) {
      this.requestService
      .getStatusStatsSuperUser({
        ownershipUserCode: this.authService.userInfo.username,
        isTransitionUvm,
      })
      .subscribe((stats) => {
        const getTotal = (statusCodes: string[]) =>
          stats
            .filter((s) => statusCodes.includes(s.status))
            .reduce((sum, s) => sum + s.total, 0);

        this.totalToComplete = getTotal(['BOZ','APE']);
        this.totalToManage = getTotal(['PIC','SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST','TPA']);
        this.totalClosed = getTotal(['END', 'DEL','CHI']);
        this.totalToManageNEW = getTotal(['NEW']);
        this.totalToManagePIC = getTotal(['PIC']);
        this.totalToManageSS = getTotal(['SS']);
        this.totalToManageCP = getTotal(['CP']);
        this.totalToManageCS = getTotal(['CS']);
        this.totalToManageDAT = getTotal(['DAT']);
        this.totalToManageTPV = getTotal(['TPV']);
        this.totalToManageTPA = getTotal(['TPA']);
        this.totalToManageVAL = getTotal(['VAL']);
        this.totalToManageCPZ = getTotal(['CPZ']);
        this.totalToManageCST = getTotal(['CST']);
        this.totalClosedEND = getTotal(['END']);
        this.totalClosedDEL = getTotal(['DEL']);
        this.totalClosedCHI = getTotal(['CHI']);

        this.totalUvmSol1 = getTotal(['SOL1']);
        this.totalUvmSol2 = getTotal(['SOL2']);
        this.totalUvmSol3 = getTotal(['SOL3']);
        this.totalUvmSol = getTotal(['SOL1', 'SOL2', 'SOL3']);

      this.refreshData();
      this.isReloading = false;
      // this.scheduleReload();
      });
    } else {
      this.requestService
      .getStatusStats({
        ownershipUserCode: this.authService.userInfo.username,
        isTransitionUvm,
      })
      .subscribe((stats) => {
        const getTotal = (statusCodes: string[]) =>
          stats
            .filter((s) => statusCodes.includes(s.status))
            .reduce((sum, s) => sum + s.total, 0);

        this.totalToComplete = getTotal(['BOZ','APE']);
        this.totalToManage = getTotal(['PIC','SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST','TPA']);
        this.totalClosed = getTotal(['END', 'DEL','CHI']);
        this.totalToManageNEW = getTotal(['NEW']);
        this.totalToManagePIC = getTotal(['PIC']);
        this.totalToManageSS = getTotal(['SS']);
        this.totalToManageCP = getTotal(['CP']);
        this.totalToManageCS = getTotal(['CS']);
        this.totalToManageDAT = getTotal(['DAT']);
        this.totalToManageTPV = getTotal(['TPV']);
        this.totalToManageTPA = getTotal(['TPA']);
        this.totalToManageVAL = getTotal(['VAL']);
        this.totalToManageCPZ = getTotal(['CPZ']);
        this.totalToManageCST = getTotal(['CST']);
        this.totalClosedEND = getTotal(['END']);
        this.totalClosedDEL = getTotal(['DEL']);
        this.totalClosedCHI = getTotal(['CHI']);

        this.totalUvmSol1 = getTotal(['SOL1']);
        this.totalUvmSol2 = getTotal(['SOL2']);
        this.totalUvmSol3 = getTotal(['SOL3']);
        this.totalUvmSol = getTotal(['SOL1', 'SOL2', 'SOL3']);

      this.refreshData();
      this.isReloading = false;
      // this.scheduleReload();
      });
    }
    
    
    
  }

  loadRequests(): void {
    this.requestsToComplete = [];
    const isTransitionUvm =
      this.selectedContext.value === 'ONLY_UVM'
        ? true
        : this.selectedContext.value === 'NO_UVM'
        ? false
        : undefined;

    const request: FindRequestDto = {
      page: 0,
      size: 10,
      sortBy: 'lastOwnership',
      sortDirection: 'desc',
      isTransitionUvm,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
      },
      statusCodes: ['PIC','SS', 'NEW', 'CP', 'CS', 'BOZ','DAT','TPV','VAL','CPZ','CST','APE','TPA'],
    };
    this.requestService.getRequests(request).subscribe((res) => {
      this.ownRequest = res.transitions;
    });

    const request2: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
        withPastUserOwnership: true,
      },
      statusCodes: ['PIC', 'SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST','TPA'],
    };
    this.requestService.getRequests(request2).subscribe((res) => {
      this.requestsToManage = res.transitions;
    });

    const request3: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
        withPastUserOwnership: true,
      },
      statusCodes: ['END', 'DEL','CHI'],
    };
    this.requestService.getRequests(request3).subscribe((res) => {
      this.closedRequests = res.transitions;
    });

    const request4: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
        withPastUserOwnership: true,
      },
      statusCodes: ['BOZ','APE'],
    };
    this.requestService.getRequests(request4).subscribe((res) => {
      this.requestsToComplete = res.transitions;
    });
  }

  loadRequestsForSuperUser(): void {
    this.requestsToComplete = [];
    const isTransitionUvm =
      this.selectedContext.value === 'ONLY_UVM'
        ? true
        : this.selectedContext.value === 'NO_UVM'
        ? false
        : undefined;

    const request: FindRequestDto = {
      page: 0,
      size: 10,
      sortBy: 'lastOwnership',
      sortDirection: 'desc',
      isTransitionUvm,
      statusCodes: ['PIC','SS', 'NEW', 'CP', 'CS', 'BOZ','DAT','TPV','VAL','CPZ','CST','APE','TPA'],
    };
    this.requestService.getRequests(request).subscribe((res) => {
      this.ownRequest = res.transitions;
    });

    const request2: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      statusCodes: ['PIC', 'SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST','TPA'],
    };
    this.requestService.getRequests(request2).subscribe((res) => {
      this.requestsToManage = res.transitions;
    });

    const request3: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      statusCodes: ['END', 'DEL','CHI'],
    };
    this.requestService.getRequests(request3).subscribe((res) => {
      this.closedRequests = res.transitions;
    });

    const request4: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm,
      statusCodes: ['BOZ','APE'],
    };
    this.requestService.getRequests(request4).subscribe((res) => {
      this.requestsToComplete = res.transitions;
    });
  }

  loadRequestsForUvm(): void {
    const request: FindRequestDto = {
      page: 0,
      size: 10,
      sortBy: 'lastOwnership',
      sortDirection: 'desc',
      isTransitionUvm: true,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
      },
      statusCodes: ['PIC', 'SS', 'NEW', 'CP', 'CS','TPV','CPZ','CST','VAL'],
    };
    this.requestService.getRequests(request).subscribe((res) => {
      this.ownRequest = res.transitions;
    });

    const request1: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm: true,
      isUvmFilled: false,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
        withPastUserOwnership: false,
      },
      statusCodes: ['PIC', 'NEW','TPV'],
    };
    this.requestService.getRequests(request1).subscribe((res) => {
      this.requestsToComplete = res.transitions?.filter(
        (t) => t.uvmFilled != true
      );
    });
  }

  loadRequestsForUvcp(): void {
    const request: FindRequestDto = {
      page: 0,
      size: 10,
      sortBy: 'lastOwnership',
      sortDirection: 'desc',
      isTransitionUvm: true,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
      },
      statusCodes: ['TPV', 'VAL','CPZ','CST', 'SS'],
    };
    this.requestService.getRequests(request).subscribe((res) => {
      this.ownRequest = res.transitions;
    });

    const request1: FindRequestDto = {
      page: 0,
      size: 10,
      isTransitionUvm: true,
      isUvmFilled: false,
      transitionFindOwnershipRequest: {
        ownershipUserCode: this.authService.userInfo.username,
        withCurrentUserOwnership: true,
        withPastUserOwnership: false,
      },
      statusCodes: ['TPV'],
    };
    this.requestService.getRequests(request1).subscribe((res) => {
      this.requestsToComplete = res.transitions;
    });
  }

  private refreshData() {
    this.linksToManage = [
      {
        label: `${this.totalToManageNEW} Nuove Richieste`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['NEW'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManagePIC} Prese in Carico`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['PIC'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageSS} Scelta struttura`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['SS'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageCS} In Conferma Struttura`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['CS'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageCP} In Conferma Paziente`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['CP'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageDAT} Da Trasmettere`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['DAT'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageTPV} Trasmessa`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['TPV'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageTPA} Trasmessa per Arruolamento`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['TPA'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageVAL} Valutate`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['VAL'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageCPZ} In Arruolamento`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['CPZ'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalToManageCST} Arruolate`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['CST'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: 'Visualizza tutte',
        route: '/request-list',
        queryParams: {
          statusCodes: ['PIC', 'SS', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST','TPA'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
    ];
    this.linksClosed = [
      {
        label: `${this.totalClosedEND} Completate`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['END'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalClosedDEL} Annullate`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['DEL'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalClosedCHI} Chiuse`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['CHI'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: 'Visualizza tutte',
        route: '/request-list',
        queryParams: {
          statusCodes: ['DEL', 'END','CHI'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
    ];

    this.linksSol = [
      {
        label: `${this.totalUvmSol1} Primo sollecito`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['SOL1'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalUvmSol2} Secondo sollecito`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['SOL2'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: `${this.totalUvmSol3} Terzo sollecito`,
        route: '/request-list',
        queryParams: {
          statusCodes: ['SOL3'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
      {
        label: 'Visualizza tutte',
        route: '/request-list',
        queryParams: {
          statusCodes: ['SOL1', 'SOL2', 'SOL3'],
          withPastUserOwnership: true,
          withCurrentUserOwnership: true,
        },
      },
    ];
  }

  onContextChange(context: any): void {
    this.selectedContext = context;
    this.loadStats();
    if (this.authService.isOperatoreUvm) {
      this.loadRequestsForUvm();
    } else if(this.authService.isOperatoreUvcp) {
    } else if(this.authService.isOperatoreSuperUser) {
      this.loadRequestsForSuperUser();
    } else {
      this.loadRequests();
    }
  }
}
